export const ENABLE_LOADER = 'ENABLE_LOADER';
export const DISABLE_LOADER = 'DISABLE_LOADER';

export const SAVE_USERNAME = 'SAVE_USERNAME';

// Register 
export const VALIDATION_USERNAME_REQUEST = 'VALIDATION_USERNAME_REQUEST';
export const VALIDATION_USERNAME_RESPONSE = 'VALIDATION_USERNAME_RESPONSE';
export const VALIDATION_USERNAME_FAILED = 'VALIDATION_USERNAME_FAILED';

//verify
export const VERIFY_2FACODE_REQUEST = 'VERIFY_2FACODE_REQUEST';
export const VERIFY_2FACODE_RESPONSE = 'VERIFY_2FACODE_RESPONSE';
export const VERIFY_2FACODE_FAILED = 'VERIFY_2FACODE_FAILED';

export const VERIFY_CODE_RESPONSE = 'VERIFY_CODE_RESPONSE';

//Patient exists
export const CHECK_PATIENT_EXISTS_REQUEST = 'CHECK_PATIENT_EXISTS_REQUEST';
export const CHECK_PATIENT_EXISTS_RESPONSE = 'CHECK_PATIENT_EXISTS_RESPONSE';
export const CHECK_PATIENT_EXISTS_FAILED = 'CHECK_PATIENT_EXISTS_FAILED';

// validate email phone
export const VALIDATE_PATIENT_EMAIL_PHONE = 'VALIDATE_PATIENT_EMAIL_PHONE';
export const VALIDATE_PATIENT_EMAIL_PHONE_RESPONSE = 'VALIDATE_PATIENT_EMAIL_PHONE_RESPONSE';

//Register
export const REGISTER_REQUEST = 'REGISTER_REQUEST';
export const REGISTER_RESPONSE = 'REGISTER_RESPONSE';
export const REGISTER_FAILED = 'REGISTER_FAILED';

//Patient Details
export const GET_PATIENT_DETAILS = 'GET_PATIENT_DETAILS';
export const PATIENT_DETAILS_RESPONSE = 'PATIENT_DETAILS_RESPONSE';
export const GET_PATIENT_DETAILS_FAILED = 'GET_PATIENT_DETAILS_FAILED';

export const VALID_CLIENT_REQUEST = 'VALID_CLIENT_REQUEST';
export const VALID_CLIENT_RESPONSE = 'VALID_CLIENT_RESPONSE';
export const VALID_CLIENT_FAILED = 'VALID_CLIENT_FAILED';
export const CLEAR_DATA_REQUEST = 'CLEAR_DATA_REQUEST';
export const CLEAR_DATA_RESPONSE = 'CLEAR_DATA_RESPONSE';
export const UPDATE_ROOM_STATUS = 'UPDATE_ROOM_STATUS';
export const UPDATE_ROOM_STATUS_SUCCESS = 'UPDATE_ROOM_STATUS_SUCCESS';
export const CLEAR_ROOM_STATUS = 'CLEAR_ROOM_STATUS';

//get children
export const GET_CHILDREN_REQUEST = 'GET_CHILDREN_REQUEST';
export const GET_CHILDREN_RESPONSE = 'GET_CHILDREN_RESPONSE';
export const GET_CHILDREN_FAILED = 'GET_CHILDREN_FAILED';
// Add Children
export const ADD_CHILDREN_REQUEST = 'ADD_CHILDREN_REQUEST';
export const ADD_CHILDREN_RESPONSE = 'ADD_CHILDREN_RESPONSE';
export const ADD_CHILDREN_FAILED = 'ADD_CHILDREN_FAILED';
// add family member
export const ADD_FAMILY_MEMBER_REQUEST = 'ADD_FAMILY_MEMBER_REQUEST';
export const ADD_FAMILY_MEMBER_RESPONSE = 'ADD_FAMILY_MEMBER_RESPONSE';


//reset all data
export const RESET_REGISTER_DATA = 'RESET_REGISTER_DATA';
export const RESET_PATIENT_DATA = 'RESET_PATIENT_DATA';

// Add user details
export const ADD_USER_DETAILS_REQUEST = 'ADD_USER_DETAILS_REQUEST';
export const ADD_USER_DETAILS_RESPONSE = 'ADD_USER_DETAILS_RESPONSE';
export const ADD_USER_DETAILS_FAILED = 'ADD_USER_DETAILS_FAILED';

export const GET_CHECK_USER_DETAILS_SIGNED = 'GET_CHECK_USER_DETAILS_SIGNED';
export const GET_CHECK_USER_DETAILS_SIGNED_RESPONSE = 'GET_CHECK_USER_DETAILS_SIGNED_RESPONSE';

// Get Doc From Alias
export const GET_DOC_REQUEST = 'GET_DOC_REQUEST';
export const GET_DOC_RESPONSE = 'GET_DOC_RESPONSE';
export const GET_DOC_FAILED = 'GET_DOC_FAILED';

// Get Room Tokens
export const GET_ROOM_KEYS_REQUEST = 'GET_ROOM_KEYS_REQUEST';
export const GET_ROOM_KEYS_RESPONSE = 'GET_ROOM_KEYS_RESPONSE';
export const GET_ROOM_KEYS_FAILED = 'GET_ROOM_KEYS_FAILED';

// Add User To Room
export const ADD_USER_TO_WAITING_REQUEST = 'ADD_USER_TO_WAITING_REQUEST';
export const ADD_USER_TO_WAITING_RESPONSE = 'ADD_USER_TO_WAITING_RESPONSE';
export const ADD_USER_TO_WAITING_FAILED = 'ADD_USER_TO_WAITING_FAILED';

//Generate callid by patient
export const GENERATE_CALLID_REQUEST = 'GENERATE_CALLID_REQUEST';
export const GENERATE_CALLID_RESPONSE = 'GENERATE_CALLID_RESPONSE';
export const GENERATE_CALLID_FAILED = 'GENERATE_CALLID_FAILED';

//Notify Provider
export const NOTIFY_PROVIDER_REQUEST = 'NOTIFY_PROVIDER_REQUEST';
export const NOTIFY_PROVIDER_RESPONSE = 'NOTIFY_PROVIDER_RESPONSE';
export const NOTIFY_PROVIDER_FAILED = 'NOTIFY_PROVIDER_FAILED';

//Check room status
export const CHECK_ROOM_STATUS_REQUEST = 'CHECK_ROOM_STATUS_REQUEST';
export const CHECK_ROOM_STATUS_RESPONSE = 'CHECK_ROOM_STATUS_RESPONSE';
export const CHECK_ROOM_STATUS_FAILED = 'CHECK_ROOM_STATUS_FAILED';

// Call End By Patient
export const CALL_END_BY_PATIENT_REQUEST = 'CALL_END_BY_PATIENT_REQUEST';

// Disconnect Reason
export const DISCONNECT_REASON_REQUEST = 'DISCONNECT_REASON_REQUEST';
export const PROVIDER_SETTINGS_REQUEST = 'PROVIDER_SETTINGS_REQUEST';
export const INVALIDATE_REQUEST = 'INVALIDATE_REQUEST';

// Store Children Data
export const ADD_SELECTED_CHILD = 'ADD_SELECTED_CHILD';
export const REMOVE_SELECTED_CHILD = 'REMOVE_SELECTED_CHILD';
// Medication Search
export const MEDICATION_SEARCH = 'MEDICATION_SEARCH';
export const MEDICATION_SEARCH_SUCCESS = 'MEDICATION_SEARCH_SUCCESS';

// Allergy Search
export const ALLERGY_SEARCH = 'ALLERGY_SEARCH';
export const ALLERGY_SEARCH_SUCCESS = 'ALLERGY_SEARCH_SUCCESS';

// upload medication
export const UPLOAD_MEDICATIONS = 'UPLOAD_MEDICATIONS';
export const UPLOAD_MEDICATIONS_SUCCESS = 'UPLOAD_MEDICATIONS_SUCCESS';
// Medication Search
export const MEDICATION_STORED = 'MEDICATION_STORED';
export const MEDICATION_STORED_SUCCESS = 'MEDICATION_STORED_SUCCESS';

// Allergy Search
export const ALLERGIES_STORED = 'ALLERGIES_STORED';
export const ALLERGIES_STORED_SUCCESS = 'ALLERGIES_STORED_SUCCESS';
// store medical condition
export const MEDICAL_CONDITION_STORED = 'MEDICAL_CONDITION_STORED';
//symptoms 
export const SYMPTOMS_STORED = 'SYMPTOMS_STORED';


// Api failed Error
export const ERROR_OCCURED = 'ERROR_OCCURED';

